exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".info_btn{\r\n    float: right;\r\n     color: #2775d6;\r\n}\r\n.input_info{position: absolute; right: -25px; top:10px;color: #2775d6;}\r\n.review-heading{\r\n    color: #fff;\r\n    margin: 0;\r\n    padding: 0;\r\n    font-weight: normal;\r\n    font-size: 14px;\r\n}\r\n", ""]);

